import { useCallback } from "react";
import { api } from "./api-core";

export interface ICountry {
  country_code: string;
  country_name: string;
  created_at: string;
  id: number;
  phonecode: number;
  updated_at: string;
}

export interface IUserProfile {
  id: number;
  username: string;
  password: string;
  roleUser: string;
  avatar_url: string;
  firstname: string;
  lastname: string;
  email: string;
  email_old: string;
  day: string;
  month: string;
  year: string;
  school_id: string;
  school_name: string;
  city_id: string;
  city_name: string;
  country_id: string;
  country_name: string;
  listCity: ICity[];
  idUserMD: string;
  parent: IUserParent;
}

export interface IUserParent {
  isConnected: boolean;
  waitingConfirm: boolean;
  infoRequest: {
    parentID: string;
    nickname: string;
    firstname: string;
    lastname: string;
  };
  infoConnected: {
    parent: string;
    username: string;
    email: string;
    firstname: string;
    lastname: string;
  };
}

export interface ICity {
  id: number;
  name: string;
  country_id: string;
}

export interface ISchool {
  success: boolean;
  count: number;
  data: {
    id: number;
    province_id: number;
    country_id: number;
    STATE: string;
    SCHOOL_CODE: string;
    SCHOOL_NAME: string;
    ADDRESS: string;
    wp_user_id: string;
    group_id: string;
    is_used: string;
  }[];
}
var coutryStatic: Promise<ICountry[]>;
export const UserApi = {
  uploadAvatar: (data: { avatar: File }) => {
    const formData = new FormData();
    formData.append("avatar", data.avatar);

    const url = process.env.API_UPLOAD_AVATAR_USER;
    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error in upload avatar:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  getUserWorkspaces: () => {
    const url = process.env.API_GET_USER_WORKSPACE;
    return api.get(url as string).then((res) => res.data.data);
  },
  getUserProfile: () => {
    const url = process.env.API_GET_USER_PROFILE;
    return api.get(url as string).then((res) => res.data);
  },
  getCountryList: (): Promise<ICountry[]> => {
    if (coutryStatic) return coutryStatic;
    coutryStatic = api
      .get(process.env.API_GET_COUNTRY_LIST as string)
      .then((res) => {
        const data = res.data.data || [];
        if (Array.isArray(data) && data.length > 0) {
          return data;
        }
        throw new Error("Country data is empty or invalid");
      })
      .catch((err) => {
        console.error("Error fetching country list:", err);
        return []; // Trả về mảng rỗng khi có lỗi
      });
    return coutryStatic;
  },
  getCityByCountry(id: string): Promise<ICity> {
    const url = `${process.env.API_GET_CITY_LIST}?ID_Country=${id}`;
    return api
      .get(url)
      .then((res) => {
        return res.data.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getSchoolByCity: (page: string, state: string, school_name: string) => {
    const url =
      process.env.API_GET_SCHOOL_BY_CITY +
      `?school_name=${school_name}&page=${page}&state=${state}`;
    return api.get(url as string).then((res) => res.data);
  },
  updateProfile: (data: {
    email: string;
    email_old: string;
    username: string;
    day: string;
    month: string;
    year: string;
    school_name: string;
    city_id: string;
    country_id: string;
    first_name: string;
    last_name: string;
    idUserMD: string;
  }) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường và thêm vào formData
    Object.keys(data).forEach((key) => {
      const k = key as keyof typeof data; // Ép kiểu key là một khóa hợp lệ của đối tượng data
      if (data[k] !== undefined) {
        if (Array.isArray(data[k])) {
          // Nếu là mảng, thêm từng phần tử vào formData
          (data[k] as string[]).forEach((item) => {
            formData.append(`${k}[]`, item);
          });
        } else {
          // Nếu là chuỗi hoặc các kiểu đơn giản khác
          formData.append(k, data[k] as string);
        }
      }
    });

    const url = process.env.URL_UPDATE_PROFILE;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },
  connectParent: (data: {
    type: string;
    username_parent?: string;
    email_parent?: string;
    child_id: string;
    parent?: string;
  }) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường và thêm vào formData
    Object.keys(data).forEach((key) => {
      const k = key as keyof typeof data; // Ép kiểu key là một khóa hợp lệ của đối tượng data
      if (data[k] !== undefined) {
        if (Array.isArray(data[k])) {
          // Nếu là mảng, thêm từng phần tử vào formData
          (data[k] as string[]).forEach((item) => {
            formData.append(`${k}[]`, item);
          });
        } else {
          // Nếu là chuỗi hoặc các kiểu đơn giản khác
          formData.append(k, data[k] as string);
        }
      }
    });

    const url = process.env.API_CONNECT_PARENT;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },
  verifyEmail: (data: { email: string }) => {
    const formData = new FormData();
    formData.append("email", data.email);

    const url = process.env.API_VERIFY_EMAIL;
    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
};

export const useApiCache = () => {
  return {
    getCountryList: useCallback(UserApi.getCountryList, []),
  };
};
